<template>
  <div class="box">
    <div class="content">
      <div class="main_box">
        <div class="banner">
          <el-carousel :interval="3000" arrow="always" height="310px">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <div class="title">{{ item.journalisTitle }}</div>
              <el-image class="img" :src="echoImg(item.bannerUrl)" @click="goDetails('', item.id)"
                fit="cover"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="listBox" v-for="(item, index) in subjectList" :key="index" :class="'list_box' + index">
          <ul class="ul" :style="'border-bottom:1px solid' + color">
            <div class="li">
              <template v-if="index == 0 || index % 5 == 3">
                <div v-for="(items, index1) in item.childrenList" :key="index1">
                  <li v-if="index1 <= 1" :class="items.isCheck ? 'active' : ''"
                    :style="items.isCheck ? 'background:' + color : ''" v-on:mouseover="changeActive(index, index1)">{{
                      items.navigationName }}</li>
                </div>
              </template>
              <template v-else-if="index == 1">
                <div>
                  <li class="active" :style="'background:' + color" v-on:mouseover="changeActive(index, index1)">协会概况
                  </li>
                </div>
              </template>
              <template v-else>
                <div v-for="(items, index1) in item.childrenList" :key="index1">
                  <li v-if="index1 <= 4" :class="items.isCheck ? 'active' : ''"
                    :style="items.isCheck ? 'background:' + color : ''" v-on:mouseover="changeActive(index, index1)">{{
                      items.navigationName }}</li>
                </div>
              </template>
            </div>
            <div class="more" v-if="index == 1"
              @click="more(item.childrenList[0].navigationName, item.childrenList[0].id, item.childrenList[0].navigationType)">
              更多>>
            </div>
            <div class="more" v-else @click="more(item.navigationName, item.id, item.navigationType)">更多>></div>
          </ul>
          <div class="children_box" v-if="index == 1">
            <div class="htmlBox"
              @click="more(item.childrenList[0].navigationName, item.childrenList[0].id, item.childrenList[0].navigationType)"
              v-html="item.childrenList[0].content">
            </div>
          </div>
          <div class="children_box" v-else>
            <ul class="children" v-for="(date, idx) in item.childrenList" :key="idx"
              :class="date.isCheck ? 'itemActive' : ''">
              <template v-for="(dates, idxs) in date.newsList" @key="idxs">
                <li v-if="idxs < 6" @click="goDetails(item.navigationName, dates.id)" :key="idxs">
                  <div class="title">{{ dates.title }}</div>
                  <div class="time">{{ toDate(dates.releaseTime, "yyyy-MM-dd") }}</div>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>

      <div class="threeImg">
        <div class="title" :style="'background:' + color">精彩图库</div>
        <div class="Containt">
          <ul :style="{ left: calleft + 'px', width: widthData + 'px' }" v-on:mouseover="stopMove()"
            v-on:mouseout="move()" class="imgBoxoul">
            <li v-for="(item, index) in mapDepotList" :key="index" ref="lis">
              <el-image class="img" :src="echoImg(item.bannerUrl)" @click="goDetails('', item.id)"
                fit="cover"></el-image>
            </li>
            <li v-for="(dates, idx) in mapDepotList" :key="'c_' + idx" ref="lis1">
              <el-image class="img" :src="echoImg(dates.bannerUrl)" @click="goDetails('', dates.id)"
                fit="cover"></el-image>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  selectLink,
  selectMapDepot,
  selectBanner,
  getNavigationTwoList,
  getNavigationTemplate,
  websiteListGetJournalismId,
  getTextarea,
  navigation,
} from "@/api/template";
export default {
  name: "Index",
  components: {},
  data() {
    return {
      linksList: [],
      mapDepotList: [],
      bannerList: [],
      subjectList: [],
      liBoxML: 0,
      childrenList: [],
      calleft: 0,
      speed: 1,
      timer: "",
      dataInfo: {},
      details: {},
    };
  },
  created() {
    this.init();
    this.move();
    this.$store.commit("hideLoading");
  },
  computed: {
    widthData() {
      return 320 * Number(this.mapDepotList.length * 2);
    },
    ...mapState(["color"]),
  },
  mounted() {
    let imgBox = document.getElementsByClassName("imgBoxoul")[0];
    imgBox.innerHTML += imgBox.innerHTML;
  },
  methods: {
    init() {
      this.getSelectBanner();
      this.navigation()
      // this.getNavigationTwoList();
      this.getSelectMapDepot();
      // this.getSelectLink()
      // this.initData()
    },
    getTextareaFun(journalisContent) {
      let params = {
        journalisContent: journalisContent,
      };
      getTextarea(params).then((res) => {
        return res.data.dataHtml
      });
    },
    getSelectLink() {
      let self = this;
      selectLink().then((res) => {
        if (res.code == 200) {
          this.linksList = res.data;
        } else {
          self.$message(res.msg);
        }
      }).catch(() => { });
    },
    getSelectBanner() {
      let self = this;
      selectBanner().then((res) => {
        if (res.code == 200) {
          this.bannerList = res.data;
        } else {
          self.$message(res.msg);
        }
      }).catch(() => { });
    },
    getSelectMapDepot() {
      let self = this;
      selectMapDepot().then((res) => {
        if (res.code == 200) {
          this.mapDepotList = res.data;
        } else {
          self.$message(res.msg);
        }
      }).catch(() => { });
    },
    navigation() {
      let self = this;
      navigation().then((res) => {
        if (res.code == 200) {
          let list = [
            {
              id: '', navigationName: '', navigationType: '', childrenList: [
                { navigationName: '新闻动态', isCheck: true, newsList: [] },
                { navigationName: '公告', isCheck: false, newsList: [] },
              ]
            },
            {
              id: '', navigationName: '', navigationType: '', childrenList: [
                { navigationName: '协会概况', isCheck: true, content: '', id: '' },
              ]
            },
            {
              id: '', navigationName: '', navigationType: '', childrenList: [
                { navigationName: '公益活动', isCheck: true, newsList: [] },
                { navigationName: '交流活动', isCheck: false, newsList: [] },
                { navigationName: '体育展览', isCheck: false, newsList: [] },
                { navigationName: '场馆论坛', isCheck: false, newsList: [] },
              ],
            },
            {
              id: '', navigationName: '', navigationType: '', childrenList: [
                { navigationName: '政策法规', isCheck: true, newsList: [] },
              ],
            },
            {
              id: '', navigationName: '', navigationType: '', childrenList: [
                { navigationName: '行业标准', isCheck: true, newsList: [] },
                { navigationName: '建设项目', isCheck: false, newsList: [] },
                { navigationName: '场馆普查', isCheck: false, newsList: [] },
                { navigationName: '招标采购', isCheck: false, newsList: [] },
              ],
            },
            {
              id: '', navigationName: '', navigationType: '', childrenList: [
                { navigationName: '会员服务', isCheck: true, newsList: [] },
                { navigationName: '活动报名', isCheck: false, newsList: [] },
                { navigationName: '入会须知', isCheck: false, newsList: [] },
                { navigationName: '办事指南', isCheck: false, newsList: [] },
              ],
            },
          ]
          let data = res.data.navigation
          data.forEach(el => {
            if (el.navigationName == '新闻资讯') {
              list[0].id = el.id
              list[0].navigationName = el.navigationName
              list[0].navigationType = el.navigationType
              list[0].childrenList[0].newsList = el.childrenList.filter(e => e.navigationName == '新闻')[0].newsList.slice(0, 6)
              list[0].childrenList[1].newsList = el.childrenList.filter(e => e.navigationName == '公告')[0].newsList.slice(0, 6)
              list[0].childrenList.forEach(el2 => {
                el2['navigationType'] = el.navigationType
              })
            } else if (el.navigationName == '场馆协会') {
              list[1].id = el.id
              list[1].navigationName = el.navigationName
              list[1].navigationType = el.navigationType
              let params = {
                journalisContent: el.newsList[0].content,
              };
              getTextarea(params).then((res) => {
                list[1].childrenList[0].content = res.data.dataHtml
              });
              list[1].childrenList.forEach(el2 => {
                el2['navigationType'] = el.navigationType
                el2['id'] = el.id
              })
            } else if (el.navigationName == '活动交流') {
              list[2].id = el.id
              list[2].navigationName = el.navigationName
              list[2].navigationType = el.navigationType
              list[2].childrenList[0].newsList = el.childrenList.filter(e => e.navigationName == '公益活动')[0].newsList.slice(0, 6)
              list[2].childrenList[1].newsList = el.childrenList.filter(e => e.navigationName == '交流活动')[0].newsList.slice(0, 6)
              list[2].childrenList[2].newsList = el.childrenList.filter(e => e.navigationName == '体育展览')[0].newsList.slice(0, 6)
              list[2].childrenList[3].newsList = el.childrenList.filter(e => e.navigationName == '场馆论坛')[0].newsList.slice(0, 6)
              list[2].childrenList.forEach(el2 => {
                el2['navigationType'] = el.navigationType
              })
            } else if (el.navigationName == '政策法规') {
              list[3].id = el.id
              list[3].navigationName = el.navigationName
              list[3].navigationType = el.navigationType
              list[3].childrenList[0].newsList = el.childrenList.filter(e => e.navigationName == '政策法规')[0].newsList.slice(0, 6)
              list[3].childrenList.forEach(el2 => {
                el2['navigationType'] = el.navigationType
              })
            } else if (el.navigationName == '场馆资讯') {
              list[4].id = el.id
              list[4].navigationName = el.navigationName
              list[4].navigationType = el.navigationType
              list[4].childrenList[0].newsList = el.childrenList.filter(e => e.navigationName == '行业标准')[0].newsList.slice(0, 6)
              list[4].childrenList[1].newsList = el.childrenList.filter(e => e.navigationName == '建设项目')[0].newsList.slice(0, 6)
              list[4].childrenList[2].newsList = el.childrenList.filter(e => e.navigationName == '场馆展示')[0].newsList.slice(0, 6)
              list[4].childrenList[3].newsList = el.childrenList.filter(e => e.navigationName == '招标采购')[0].newsList.slice(0, 6)
              list[4].childrenList.forEach(el2 => {
                el2['navigationType'] = el.navigationType
              })
            }
          })
          this.subjectList = list
        } else {
          self.$message(res.msg);
        }
      }).catch(() => { });
    },
    getNavigationTwoList() {
      let self = this;
      getNavigationTwoList().then((res) => {
        if (res.code == 200) {
          res.data.forEach((dates) => {
            dates.witemVo.forEach((item, index) => {
              if (index == 0) {
                item.isCheck = true;
                this.childrenList = item;
              } else {
                item.isCheck = false;
              }
              item.journalism.forEach((its, idx) => {
                if (idx == 0) {
                  its.isCheck = true;
                } else {
                  its.isCheck = false;
                }
              });
            });
          });
          this.subjectList = res.data;
        } else {
          self.$message(res.msg);
        }
      }).catch(() => { });
    },
    openLinks(linkUrl) {
      window.open(linkUrl, "_blank");
    },
    more(navigationName, id, type) {
      let data = {
        name: navigationName,
        id: id,
        type: type,
      };
      window.sessionStorage.setItem("navigationValue", JSON.stringify(data));
      // this.$router.push({
      //   params: { name: navigationName, id: id },
      //   name: "second-list",
      // });
      this.$router.push({ params: { name: navigationName, id: id, type: type, index: '0' }, name: 'second2-list' })
    },
    goDetails(navigationName, id) {
      let data = {
        name: navigationName,
        id: id,
      };
      window.sessionStorage.setItem("detailsValue", JSON.stringify(data));
      this.$router.push("/second2-details");
    },
    changeActive(index, idx) {
      this.subjectList[index].childrenList.forEach((item, num) => {
        if (idx == num) {
          item.isCheck = true;
          this.newsList = item;
        } else {
          item.isCheck = false;
        }
      });
    },
    move() {
      this.timer = setInterval(this.starMove, 20);
    },
    //开始移动
    starMove() {
      this.calleft -= 1.2; //*this.speed
      if (this.calleft <= -this.mapDepotList.length * 320) {
        this.calleft = 0;
      }
    },
    //鼠标悬停时停止移动
    stopMove() {
      clearInterval(this.timer);
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 1200px;
  margin: 0 auto;

  .main_box {
    display: flex;
    flex-flow: row wrap;
    justify-content: start;
    font-size: 16px;

    .banner {
      width: 576px;
      height: 310px;
      margin-top: 20px;

      .img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }

      .title {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.6);
        z-index: 99;
        color: #fff;
        height: 56px;
        line-height: 56px;
        padding: 0 20px;
      }
    }

    .listBox {
      height: 310px;
      margin-top: 20px;
      float: left;
      overflow-y: hidden;
      background: #fff;

      .ul {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;

        .li {
          display: flex;
          //flex-flow:row wrap;
          justify-content: start;
          white-space: nowrap;
          overflow-x: hidden;

          li {
            padding: 0 20px;
            cursor: pointer;
          }

          .active {
            color: #fff;
            background: #4ab344;
          }

          li:hover {
            color: #fff;
            background: #4ab344;
          }
        }

        .more {
          width: 100px;
          float: right;
          text-align: right;
          font-size: 12px;
          cursor: pointer;
          padding-right: 16px;
          box-sizing: border-box;
        }
      }

      .children_box {
        position: relative;

        .htmlBox {
          width: 100%;
          height: 250px;
          padding: 10px 10px 0;
          box-sizing: border-box;
          overflow: hidden;
          cursor: pointer;
        }

        .children {
          display: none;
          padding: 0 10px;

          li {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px dashed #e8e8e8;
            cursor: pointer;

            .title {
              float: left;
              width: 70%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .time {
              float: right;
              width: 30%;
              text-align: right;
            }
          }

          li:last-child {
            border-bottom: none;
          }
        }

        .itemActive {
          display: block;
          animation: myMou 1.2s ease-out;
          animation-fill-mode: forwards;
        }
      }
    }

    .list_box0 {
      width: 604px;
      margin-left: 20px;

      .ul {
        border-bottom: 1px solid #4ab344;
      }

      .li {
        width: 500px;

        li {
          width: 230px;
          text-align: center;
        }
      }
    }

    .list_box1,
    .list_box6,
    .list_box11 {
      width: 320px;

      .ul {
        border-bottom: 1px solid #4ab344;
      }

      .li {
        width: 220px;
      }
    }

    .list_box2,
    .list_box7,
    .list_box12 {
      width: 520px;
      margin-left: 12px;
      margin-right: 12px;

      .ul {
        border-bottom: 1px solid #4ab344;
      }

      .li {
        width: 420px;
      }
    }

    .list_box3,
    .list_box8,
    .list_box13 {
      width: 336px;

      .ul {
        border-bottom: 1px solid #4ab344;
      }

      .li {
        width: 236px;
      }
    }

    .list_box4,
    .list_box9,
    .list_box14 {
      width: 598px;

      .ul {
        border-bottom: 1px solid #4ab344;
      }

      .li {
        width: 498px;
      }
    }

    .list_box5,
    .list_box10,
    .list_box15 {
      width: 588px;
      margin-left: 12px;

      .ul {
        border-bottom: 1px solid #4ab344;
      }

      .li {
        width: 488px;
      }
    }
  }
}

.listBox {
  position: relative;
}

.threeImg {
  position: relative;
  background: #fff;
  margin-top: 20px;

  .title {
    height: 45px;
    line-height: 45px;
    color: #fff;
    background: #4ab344;
    padding: 0 10px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    font-size: 16px;
  }

  .Containt {
    position: relative;
    padding: 20px 0;
    overflow-y: auto;
    width: 1200px;
    height: 190px;
    overflow: hidden;
    margin: 0 auto;

    ul {
      margin: 0 auto;
      width: 1200px;
      height: 190px;
      position: absolute;
      left: 0px;
      cursor: pointer;
      z-index: 10;
      overflow: hidden;

      li {
        float: left;
        width: 300px;
        height: 190px;
        margin-left: 20px;
        overflow: hidden;
        background-color: #ffffff;

        .img {
          width: 300px;
          height: 190px;
          cursor: pointer;
        }
      }
    }
  }
}

@keyframes myMou {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
